var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ql-container ql-snow", staticStyle: { border: "none" } },
    [
      _c("div", {
        staticClass: "ql-editor wysiwyg",
        domProps: { innerHTML: _vm._s(_vm.html) }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }